import { render, staticRenderFns } from "./CurrencyTitle.vue?vue&type=template&id=3bddd758&"
import script from "./CurrencyTitle.vue?vue&type=script&lang=ts&"
export * from "./CurrencyTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports